<template>
     <div class="gmf-cform-v2-section-title">
        <span class="gmf-subheader">{{ label }}</span>
        <span class="gmf-text-small" v-if="! isRequired && ! validationError">{{ t('comments.optional') }}</span>
        <span v-if="validationError" class="gmf-validation-error">{{ validationErrorPhrase }}</span>
    </div>
</template>

<style>
.gmf-cform-v2-section-title {
    margin-bottom: var(--gmf-p-2);
    display: flex;
    gap: var(--gmf-p-2);
    align-items: center;
}
.gmf-cform-v2-section-title .gmf-subheader {
    margin: 0;
}
.gmf-cform-v2-section-title .gmf-validation-error {
    color: var(--gmf-col-error);
    font-size: var(--gmf-text-small-font-size);
    font-weight: var(--gmf-text-small-font-weight);
}
</style>

<script>
import state from '@/state';
const t = state.t;

export default {
    props: {
        field: {
            type: String,
            required: true,
        },
        fieldType: {
            type: Object,
            required: true,
        },
        validationError: {
            type: String,
            default: null,
        },
        commentType: {
            type: String,
            required: true,
        },
    },
    methods: {
        t: state.t,
    },
    computed: {
        validationErrorPhrase () {
            const e = this.validationError;
            return t('comments.form_v2.' + this.commentType + '.' + this.field + '.validation_error.' + e)
                || t('comments.form_v2.default.' + this.field + '.validation_error.' + e)
                || t('comments.form_v2.default.default.validation_error.' + e)
                || e;
        },
        label () {
            return t('comments.form_v2.' + this.commentType + '.' + this.field + '.title') || t('comments.form_v2.default.' + this.field + '.title');
        },
        isRequired () {
            return this.fieldType.params && this.fieldType.params.required;
        },
    },
}
</script>